// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + ({"489":"body","535":"login"}[chunkId] || chunkId) + "." + {"52":"85c476be","489":"92597545","491":"eb14d985","535":"598b76ee"}[chunkId] + ".js";
};